import { createEvent, createStore } from 'effector'

export const showCastNotAllowedWidget = createEvent()
export const hideCastNotAllowedWidget = createEvent()

export const $showCastNotAllowedWidget = createStore(false)
  .on(showCastNotAllowedWidget, () => true)
  .on(hideCastNotAllowedWidget, () => false)
